import { render, staticRenderFns } from "./PendingPayment.vue?vue&type=template&id=05af3e83"
import script from "./PendingPayment.vue?vue&type=script&lang=js"
export * from "./PendingPayment.vue?vue&type=script&lang=js"
import style0 from "./PendingPayment.vue?vue&type=style&index=0&id=05af3e83&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports